export default "__VITE_ASSET__CwrMAvP2__"